(function () {
  // Wird global (theme.liquid) UND im Widget-Snippet geladen — nur einmal ausführen.
  if (window.__mbLoaded) return;
  window.__mbLoaded = true;
  // Rabatt-Link-Session (html.mb-off, gesetzt in multibuy-widget.liquid): Widget komplett inaktiv,
  // damit Submit-Interceptor und Anzahl-Selektor-Ausblendung nicht greifen.
  if (document.documentElement.classList.contains("mb-off")) return;
  var MB_HOST = "https://multibuy-alphavitalis.vercel.app"; // beim Kopieren für neuen Shop anpassen

  function fmt(n) {
    return n.toFixed(2).replace(".", ",") + " €";
  }

  function renderPrices(widget) {
    var price = parseFloat(widget.dataset.price);
    widget.querySelectorAll(".mb-tile").forEach(function (tile) {
      var qty = parseInt(tile.dataset.qty, 10);
      var type = tile.dataset.type;
      var value = parseFloat(tile.dataset.value) || 0;
      var cents = Math.round(price * 100);
      var full = (cents * qty) / 100;
      // Wie Shopify: Prozent-Rabatt pro Stück, auf Cent ABgerundet
      var final =
        type === "percent" ? ((cents - Math.floor((cents * value) / 100)) * qty) / 100
        : type === "amount" ? Math.max(0, full - value)
        : full;
      var savedEuro = (full - final).toFixed(2).replace(".", ",");
      var mode = widget.dataset.saveDisplay || "percent";
      var save = "";
      if (type === "amount") {
        save = widget.dataset.saveAmt.replace("{amt}", savedEuro);
      } else if (type === "percent") {
        var pctText = widget.dataset.savePct.replace("{pct}", value);
        save =
          mode === "amount" ? widget.dataset.saveAmt.replace("{amt}", savedEuro)
          : mode === "both" ? pctText + " (" + savedEuro + " €)"
          : pctText;
      }
      tile.querySelector(".mb-price").innerHTML =
        (type !== "none" ? "<s>" + fmt(full) + "</s>" : "") +
        "<b>" + fmt(final) + "</b>" +
        (save ? '<span class="mb-save">' + save + "</span>" : "");
      // Stückzahl-Badge (Template aus Config, Standard "{qty} Stk.")
      var qtyBadge = tile.querySelector(".mb-qtybadge");
      if (qtyBadge) {
        var qtyTpl = widget.dataset.qtyText || "{qty} Stk.";
        qtyBadge.textContent = qtyTpl.replace("{qty}", qty);
      }
      // Grundpreis (falls Produkt einen hat): auf Basis des rabattierten Preises
      var unitEl = tile.querySelector(".mb-unit");
      var unitBase = parseFloat(widget.dataset.unitBase);
      if (unitEl && unitBase && price > 0) {
        var unitNow = (final / qty) * (unitBase / price);
        unitEl.textContent = fmt(unitNow) + " / " + widget.dataset.unitLabel;
      }
    });
  }

  // Anzahl-Auswahl des Themes ausblenden – die Menge bestimmen die Kacheln.
  // Nächstliegender Vorfahre gewinnt, damit auf Seiten mit mehreren Produkten
  // (Quick-Add, Featured) nur die Auswahl des eigenen Produkts verschwindet.
  // Anzahl-Selektor des Themes: normalerweise aus (die Menge bestimmen die Kacheln),
  // bei ausgenommener Variante wieder an. Dawn rendert den Knoten beim Variantenwechsel
  // neu, deshalb jedes Mal frisch suchen statt zu cachen.
  function setThemeQuantity(widget, hidden) {
    var sel = '.product-form__quantity, .product-form__quantity-wrapper, [id^="Quantity-Form-"]';
    for (var node = widget.parentElement; node; node = node.parentElement) {
      var found = node.querySelectorAll(sel);
      if (found.length) {
        found.forEach(function (el) { el.style.display = hidden ? "none" : ""; });
        return;
      }
    }
  }

  // Ausnahmen (Backend: Deal > Ausnahmen): einzelne Varianten ohne Mengenrabatt.
  // Die IDs stehen als data-exclude-variants am Widget.
  function syncExclusion(widget, form) {
    var list = (widget.dataset.excludeVariants || "").split(",").filter(Boolean);
    var off = false;
    if (list.length && form) {
      var input = form.querySelector('[name="id"]');
      off = !!input && list.indexOf(String(input.value)) > -1;
    }
    widget.dataset.mbOff = off ? "1" : "";
    widget.classList.toggle("mb-hidden", off);
    // Steuert die !important-Regel fuer den Anzahl-Selektor im Snippet.
    // Auf der PDP gibt es genau ein Widget, deshalb reicht die Klasse am <html>.
    document.documentElement.classList.toggle("mb-vex", off);
    setThemeQuantity(widget, !off);
  }

  function selectedTile(widget) {
    return widget.querySelector(".mb-tile.mb-selected") || widget.querySelector(".mb-tile");
  }

  function setBusy(form, busy) {
    var btn = form.querySelector('[type="submit"], button[name="add"]');
    if (!btn) return;
    btn.disabled = busy;
    btn.setAttribute("aria-busy", busy ? "true" : "false");
    btn.classList.toggle("loading", busy);
    var spinner = btn.querySelector(".loading__spinner");
    if (spinner) spinner.classList.toggle("hidden", !busy);
  }

  // cart/update.js ERSETZT die komplette Code-Liste des Warenkorbs. Wird nur der neue
  // Code gesendet, verliert der zuvor per Widget gekaufte Artikel seinen Rabatt ("der
  // Rabatt springt zum zuletzt hinzugefügten Artikel"). Deshalb die vorhandenen Codes
  // kommagetrennt mitschicken. Nicht anwendbare Codes (abgelaufen/verbraucht) fallen
  // raus; fehlt das Feld `applicable`, wird der Code behalten.
  async function mbApplyCode(code) {
    var root = window.Shopify.routes.root;
    var cart = await fetch(root + "cart.js").then(function (r) { return r.json(); }).catch(function () { return {}; });
    var base = cart.total_discount || 0;
    var list = (cart.discount_codes || [])
      .filter(function (d) { return d.applicable !== false && d.code !== code; })
      .map(function (d) { return d.code; })
      .concat(code)
      .join(",");
    // Frische Codes brauchen ~2s Shopify-Propagation: anwenden, prüfen, ggf. wiederholen.
    for (var attempt = 0; attempt < 5; attempt++) {
      var upd = await fetch(root + "cart/update.js", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ discount: list }),
      }).then(function (r) { return r.json(); }).catch(function () { return {}; });
      var applied = (upd.discount_codes || []).some(function (d) {
        return d.code === code && d.applicable;
      });
      if (applied) break;
      if ((upd.total_discount || 0) > base) break;
      await new Promise(function (r) { setTimeout(r, 700); });
    }
  }

  // --- Stale-Code-Bereinigung ---------------------------------------------
  // Ein per Widget angewendeter Code bleibt am Warenkorb hängen, auch wenn die
  // Mindestmenge nicht mehr erfüllt ist (Artikel gelöscht/reduziert). Shopify
  // gewährt dann zwar KEINEN Rabatt (minimumRequirement greift), aber der Code
  // kann später wieder "aufwachen" — z. B. wenn der Kunde die Menge erneut
  // erreicht, ggf. mit einer günstigeren Variante (fester Rabattbetrag wurde
  // aus der teureren Variante berechnet). Deshalb: nicht mehr anwendbare
  // MB-Codes aktiv aus dem Warenkorb entfernen.
  var MB_CODE_RE = /^[A-HJ-NP-Z2-9]{6}$/; // genCode()-Alphabet (ohne I/O/0/1)
  var mbSuppressCleanupUntil = 0; // während buy()/Code-Propagation nicht aufräumen

  function mbRememberCode(code) {
    try {
      var list = JSON.parse(sessionStorage.getItem("mbCodes") || "[]");
      if (list.indexOf(code) < 0) list.push(code);
      sessionStorage.setItem("mbCodes", JSON.stringify(list));
    } catch (e) {}
  }

  function mbIsOwnCode(code) {
    try {
      if (JSON.parse(sessionStorage.getItem("mbCodes") || "[]").indexOf(code) >= 0) return true;
    } catch (e) {}
    // Fallback für frühere Sessions (Warenkorb überlebt sessionStorage):
    // 6 Zeichen aus dem genCode()-Alphabet = mit an Sicherheit grenzender
    // Wahrscheinlichkeit ein MultiBuy-Code. Fremde Codes ("SOMMER25" etc.)
    // haben anderes Format oder enthalten I/O/0/1.
    return MB_CODE_RE.test(code);
  }

  var mbCleanupBusy = false;
  async function mbCleanupStaleCodes() {
    if (mbCleanupBusy || Date.now() < mbSuppressCleanupUntil) return;
    mbCleanupBusy = true;
    try {
      var root = window.Shopify.routes.root;
      var cart = await fetch(root + "cart.js").then(function (r) { return r.json(); });
      var codes = cart.discount_codes || [];
      var keep = codes.filter(function (d) { return d.applicable !== false || !mbIsOwnCode(d.code); });
      if (keep.length === codes.length) return; // nichts zu tun
      await fetch(root + "cart/update.js", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ discount: keep.map(function (d) { return d.code; }).join(",") }),
      });
    } catch (e) {
      /* still bleiben — Bereinigung ist Best-Effort */
    } finally {
      mbCleanupBusy = false;
    }
  }

  // Auslöser: Seitenaufbau + jede Warenkorb-Änderung. KEIN MutationObserver auf
  // dem Drawer — der Empfehlungs-Slider darin mutiert das DOM permanent und
  // lässt jeden Debounce verhungern. Stattdessen ein Fetch-Hook: alle
  // Dawn-Warenkorb-Aktionen (Menge ändern, löschen, hinzufügen) laufen über
  // fetch auf /cart/(add|change|update|clear). Das eigene Aufräum-Update
  // triggert den Hook zwar erneut, der Folgelauf findet aber nichts mehr und
  // endet — keine Schleife.
  var mbCleanupTimer = null;
  function mbScheduleCleanup() {
    clearTimeout(mbCleanupTimer);
    mbCleanupTimer = setTimeout(mbCleanupStaleCodes, 900);
  }
  var mbOrigFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var p = mbOrigFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(mbScheduleCleanup, function () {});
    }
    return p;
  };
  mbScheduleCleanup();
  // Debug-/Test-Zugriff (bewusst öffentlich, enthält nichts Sensibles)
  window.__mbCleanup = mbCleanupStaleCodes;
  // -------------------------------------------------------------------------

  // Drawer-Inhalt still austauschen (ohne open()) — der Rabatt trifft erst nach
  // ~2s Shopify-Propagation ein; ein erneutes renderContents() würde einen vom
  // Kunden bereits geschlossenen Drawer wieder aufreißen.
  function replaceDrawerSections(sections) {
    var drawer = document.querySelector("cart-drawer");
    if (!drawer || !sections) return;
    [{ id: "cart-drawer", selector: "#CartDrawer" }, { id: "cart-icon-bubble" }].forEach(function (s) {
      var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (!el || !sections[s.id]) return;
      var src = new DOMParser().parseFromString(sections[s.id], "text/html").querySelector(s.selector || ".shopify-section");
      if (src) el.innerHTML = src.innerHTML;
    });
    // Der Overlay-Knoten wurde mit ersetzt — Klick-zum-Schließen neu verdrahten
    var overlay = drawer.querySelector("#CartDrawer-Overlay");
    if (overlay) overlay.addEventListener("click", drawer.close.bind(drawer));
  }

  async function buy(widget, form) {
    if (widget.dataset.mbOff === "1") return; // Variante vom Deal ausgenommen
    if (widget.dataset.mbBusy === "1") return; // Doppelklick-Schutz
    widget.dataset.mbBusy = "1";
    // Frisch erzeugte Codes lesen sich während der Shopify-Propagation kurz als
    // applicable:false — die Bereinigung darf sie in diesem Fenster nicht löschen.
    mbSuppressCleanupUntil = Date.now() + 25000;
    setBusy(form, true); // sofortiges Feedback: Spinner an, Button gesperrt
    try {
      var tile = selectedTile(widget);
      var qty = parseInt(tile.dataset.qty, 10);
      var type = tile.dataset.type;
      var variantId = form.querySelector('[name="id"]').value;
      var root = window.Shopify.routes.root;

      // Code-Erzeugung und Warenkorb-Add laufen PARALLEL
      var codePromise = Promise.resolve(null);
      if (type !== "none") {
        codePromise = fetch(MB_HOST + "/api/code", {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({ dealId: widget.dataset.dealId, qty: qty, variantId: Number(variantId), productId: Number(widget.dataset.productId) }),
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) { return j && j.code; })
          .catch(function () { return null; }); // Fallback: ohne Code fortfahren
      }
      // Artikel + Drawer-HTML in EINEM Request (Section Rendering von cart/add.js)
      var added = await fetch(root + "cart/add.js", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: qty }],
          sections: "cart-drawer,cart-icon-bubble",
          sections_url: window.location.pathname,
        }),
      }).then(function (r) { return r.json(); });

      var drawer = document.querySelector("cart-drawer");
      if (!drawer || typeof drawer.renderContents !== "function" || !added.sections) {
        // Kein Ajax-Drawer: Rabatt anwenden, dann klassisch zur Warenkorb-Seite
        var c = await codePromise;
        if (c) {
          mbRememberCode(c);
          await mbApplyCode(c);
        }
        window.location.href = root + "cart";
        return;
      }

      // Drawer SOFORT öffnen — der Rabatt wird angewendet, während der Kunde schaut
      drawer.renderContents(added);
      drawer.classList.remove("is-empty"); // manche Themes lassen die Klasse am Host-Element stehen

      var code = await codePromise;
      if (code) {
        mbRememberCode(code);
        await mbApplyCode(code);
        // Rabattierte Preise in den bereits offenen Drawer nachziehen
        var sections = await fetch(root + "?sections=cart-drawer,cart-icon-bubble")
          .then(function (r) { return r.json(); })
          .catch(function () { return null; });
        replaceDrawerSections(sections);
      }
    } finally {
      setBusy(form, false);
      widget.dataset.mbBusy = "";
    }
  }

  document.querySelectorAll(".mb-widget").forEach(function (widget) {
    if (widget.dataset.mbInit) return;
    widget.dataset.mbInit = "1";
    renderPrices(widget);

    var form = document.getElementById(widget.dataset.formId);
    // Blendet das Widget aus bzw. den Anzahl-Selektor ein, je nach gewaehlter Variante.
    syncExclusion(widget, form);

    widget.querySelectorAll(".mb-tile").forEach(function (tile) {
      tile.addEventListener("click", function () {
        widget.querySelectorAll(".mb-tile").forEach(function (t) { t.classList.remove("mb-selected"); });
        tile.classList.add("mb-selected");
      });
    });

    if (!form) return;
    form.addEventListener("submit", function (e) {
      if (widget.dataset.mbOff === "1") return; // ausgenommene Variante: Standardverhalten
      var tile = selectedTile(widget);
      if (parseInt(tile.dataset.qty, 10) <= 1) return; // Standardverhalten
      e.preventDefault();
      e.stopImmediatePropagation();
      buy(widget, form);
    }, true);

    // Preis bei Variantenwechsel aktualisieren
    document.addEventListener("change", function (e) {
      if (!form.contains(e.target) && !e.target.closest("variant-selects, variant-radios")) return;
      syncExclusion(widget, form);
      var priceEl = document.querySelector('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale');
      if (priceEl) {
        var raw = priceEl.textContent.replace(/[^\d,\.]/g, "").replace(",", ".");
        var p = parseFloat(raw);
        if (!isNaN(p)) { widget.dataset.price = p; renderPrices(widget); }
      }
    });
  });
})();
